import React from 'react';
import MenuItem from "./MenuItem";

import {burritos} from "./MenuList";

//images 
import burrito_img from "../../Gallery/burrito-cabreras.jpg";
import taco_img from "../../Gallery/authentic-taco-cabreras.jpg";
import enchilada_img from "../../Gallery/enchilada-cabreras.jpg";
import appetizer_img from "../../Gallery/chips-and-salsa-cabreras.jpg";
import nachos_img from "../../Gallery/nachos-cabreras.jpg";
import margarita_img from "../../Gallery/margarita-at-the-bar-cabreras.jpg";

export default function Menu() {
    return (
        <div className = "Menu">
            <MenuItem section = "Burritos" img= {burrito_img} isOpen = {true}/>
            <MenuItem section = "Street Tacos" img= {taco_img} isOpen = {false}/>
            <MenuItem section = "Enchiladas" img= {enchilada_img} isOpen = {false}/>
            <MenuItem section = "Appetizers" img= {appetizer_img} isOpen = {false}/>
            <MenuItem section = "Mexican Nachos" img= {nachos_img} isOpen = {false}/>
            <MenuItem section = "Beverages" img= {margarita_img} isOpen = {false}/>
        </div>
    )
}
